// @flow
import type {Element} from 'react'
import React from 'react'

import ChangeTitle from 'components/proposals/Part/ui/Summary/ChangeTitle'
import WYSIWYGViewer from 'components/ui/WYSIWYGViewer'
import styles from '../index.scss'

type Props = $ReadOnly<{
  section: any,
}>

function Note({section}: Props): Element<"div"> {
  return (
    <div className={styles.note}>
      <ChangeTitle title={section.title} />
      <WYSIWYGViewer value={section.value} />
    </div>
  )
}

export default Note
